import React, { useState, useEffect } from 'react'
import Breadcrumb from '../components/Breadcrumb'
import { LuLogOut, LuMapPin, LuShoppingBag, LuUser, LuTrash2 } from 'react-icons/lu'
import { Link } from 'react-router-dom'
import { FaUser, FaRupeeSign, FaDollarSign } from 'react-icons/fa';
import Config from '../API/Config';
import useLogout from '../utils/logout';
import { getAllOrders, cancelOrder } from '../API/OrderAPI';
import { PuffLoader } from 'react-spinners';
import { toast } from 'sonner';
import Swal from 'sweetalert2';
const MyOrder = () => {
  const logout = useLogout();
  const UserName = Config.getUserName();
  const UserEmail = Config.getUserEmail();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const CountryId = Config.getCountryId();
  const currencySymbol = CountryId === 'IN' ? <FaRupeeSign /> : <FaDollarSign />;

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await getAllOrders();
      if (response?.responseData) {
        setOrders(response.responseData);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      toast.error('Failed to fetch orders');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelOrder = async (orderId) => {
    const result = await Swal.fire({
      title: 'Cancel Order?',
      text: 'Are you sure you want to cancel this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, cancel it!',
    });
    if (result.isConfirmed) {
      try {
        await cancelOrder(orderId);
        fetchOrders();
        Swal.fire('Cancelled!', 'Your order has been cancelled.', 'success');
      } catch (error) {
        console.error('Error canceling order:', error);
        Swal.fire('Error!', 'Failed to cancel the order.', 'error');
      }
    }
  };

  return (
    <>
      <Breadcrumb title="My Order" path="My Order" />
      <div className="container mx-auto px-4 md:py-20 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Left Sidebar */}
          <div className="bg-[#f9f9f9] rounded-lg overflow-hidden flex-shrink-0">
            {/* Header */}
            <div className="relative md:h-36 h-24 bg-theme2">
              <div className="bg-pink-700 uppercase absolute left-1/2 md:-bottom-11 -bottom-10 transform -translate-x-1/2 
                                text-white md:w-24 w-20 md:h-24 h-20 border-4 border-white flex items-center justify-center 
                                rounded-full text-5xl shadow-md">
                {UserName ? UserName.charAt(0) : <FaUser />}
              </div>
            </div>

            {/* User Info */}
            <div className="flex flex-col items-center mt-12 px-4">
              <h3 className="font-semibold text-lg">{UserName}</h3>
              <p className="text-sm text-gray-500">{UserEmail}</p>
            </div>

            {/* Menu */}
            <ul
              className="md:mt-8 mt-4 md:pb-6 pb-2 flex flex-row md:flex-col 
                            md:space-y-2 space-x-2 md:space-x-0 md:pl-4
                            overflow-x-auto md:overflow-visible flex-nowrap"
            >
              <Link
                to={"/profile"}
                className="flex items-center whitespace-nowrap md:text-lg text-sm py-1.5 px-2 md:gap-3 gap-1 text-gray-600 cursor-pointer hover:text-theme2 transition"
              >
                <LuUser className="md:text-lg text-sm" /> Edit Profile
              </Link>
              <Link
                to={"/my-order"}
                className="flex items-center whitespace-nowrap md:text-lg text-sm py-1.5 px-2 md:gap-3 gap-1 text-theme2 font-semibold cursor-pointer md:border-b-0 md:border-r-4 border-theme2"
              >
                <LuShoppingBag className="md:text-lg text-sm" /> My Order
              </Link>
              <Link
                to={"/my-address"}
                className="flex items-center whitespace-nowrap md:text-lg text-sm py-1.5 px-2 md:gap-3 gap-1 text-gray-600 cursor-pointer hover:text-theme2 transition"
              >
                <LuMapPin className="md:text-lg text-sm" /> My Address
              </Link>
              <Link onClick={logout} className="flex items-center whitespace-nowrap md:text-lg text-sm py-1.5 px-2 md:gap-3 gap-1 text-gray-600 cursor-pointer hover:text-theme2 transition">
                <LuLogOut className="md:text-lg text-sm" /> Log Out
              </Link>
            </ul>
          </div>

          {/* Right Section */}
          <div className="lg:col-span-3 bg-[#f9f9f9] rounded-lg shadow p-3 md:p-6">
            <div className="loader-line"></div>
            <h2 className="md:text-2xl text-xl font-semibold pb-3 mb-4 mt-2">
              My Orders
            </h2>

            <div className="space-y-3 md:space-y-4">
              {loading ? (
                <div className="space-y-3 md:space-y-4">
                  {[1, 2, 3].map((item) => (
                    <div key={item} className="bg-white rounded-lg shadow-sm border border-gray-100 p-3 md:p-4">
                      {/* Mobile Placeholder */}
                      <div className="block md:hidden">
                        <div className="flex items-start gap-3 mb-3">
                          <div className="w-12 h-12 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-lg animate-pulse flex-shrink-0"></div>
                          <div className="flex-1 min-w-0">
                            <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse mb-2"></div>
                            <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-24 mb-2"></div>
                            <div className="flex items-center justify-between">
                              <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-full animate-pulse w-16"></div>
                              <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-20"></div>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                          <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-32"></div>
                          <div className="flex items-center gap-2">
                            <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-full animate-pulse w-20"></div>
                            <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-6"></div>
                          </div>
                        </div>
                      </div>

                      {/* Desktop Placeholder */}
                      <div className="hidden md:block">
                        <div className="flex items-center gap-4 border-b border-gray-200 pb-4">
                          <div className="w-16 h-16 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-lg animate-pulse flex-shrink-0"></div>
                          <div className="flex-1">
                            <div className="flex items-start justify-between">
                              <div>
                                <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse mb-2 w-64"></div>
                                <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-32"></div>
                              </div>
                              <div className="text-right">
                                <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-40 mb-2"></div>
                                <div className="h-6 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-full animate-pulse w-20"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between pt-4">
                          <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-40"></div>
                          <div className="flex items-center gap-3">
                            <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-full animate-pulse w-24"></div>
                            <div className="h-8 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded animate-pulse w-8"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : orders.length > 0 ? (
                orders.map((order) => (
                  <div
                    key={order.Id}
                    className="bg-white rounded-lg shadow-sm border border-gray-100 p-3 md:p-4 hover:shadow-md transition-shadow duration-200"
                  >
                    {/* Mobile Layout */}
                    <div className="block md:hidden">
                      {/* Header */}
                      <div className="flex items-start gap-3 mb-3">
                        <img
                          src={order.Items?.[0]?.ProductThumbImage || 'https://via.placeholder.com/64'}
                          alt={order.Items?.[0]?.ProductName || 'Product'}
                          className="w-12 h-12 rounded-lg object-cover border flex-shrink-0"
                        />
                        <div className="flex-1 min-w-0">
                          <h3 className="font-semibold text-base text-darktext truncate">
                            {order.Items?.[0]?.ProductName || 'Order'}
                            {order.Items?.length > 1 && ` +${order.Items.length - 1} more`}
                          </h3>
                          <p className="text-xs text-contentcolor mt-1">
                            Order #{order.OrderNo}
                          </p>
                          <div className="flex items-center justify-between mt-2">
                            <span
                              className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${order.OrderStatus === "PENDING" ? "bg-orange-100 text-orange-600" :
                                  order.OrderStatus === "CONFIRMED" ? "bg-blue-100 text-blue-600" :
                                    order.OrderStatus === "PREPARING" ? "bg-yellow-100 text-yellow-600" :
                                      order.OrderStatus === "PICKED" ? "bg-purple-100 text-purple-600" :
                                        order.OrderStatus === "DELIVERED" ? "bg-green-100 text-green-600" :
                                          order.OrderStatus === "CANCELED" ? "bg-red-100 text-red-600" :
                                            order.OrderStatus === "REJECTED" ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-600"
                                }`}
                            >
                              {order.OrderStatus}
                            </span>
                            <p className="text-sm font-semibold text-darktext flex items-center">
                              {currencySymbol} {order.Total}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Date and Actions */}
                      <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                        <p className="text-xs text-contentcolor">
                          {new Date(order.EntDt).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          })} • {new Date(order.EntDt).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </p>

                        <div className="flex items-center gap-2">
                          <Link
                            to={`/order-details/${order.Id}`}
                            className="bg-theme2 hover:bg-black transition-colors duration-300 text-white px-3 py-1.5 rounded-full font-medium text-xs"
                          >
                            View Details
                          </Link>
                          {order.OrderStatus === "PENDING" && (
                            <button
                              onClick={() => handleCancelOrder(order.Id)}
                              className="text-red-500 hover:text-red-700 transition-colors p-1"
                            >
                              <LuTrash2 size={16} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Desktop Layout */}
                    <div className="hidden md:block">
                      {/* Top Section */}
                      <div className="flex items-center gap-4 border-b border-gray-200 pb-4">
                        <img
                          src={order.Items?.[0]?.ProductThumbImage || 'https://via.placeholder.com/64'}
                          alt={order.Items?.[0]?.ProductName || 'Product'}
                          className="w-16 h-16 rounded-lg object-cover border flex-shrink-0"
                        />
                        <div className="flex-1">
                          <div className="flex items-start justify-between">
                            <div>
                              <h3 className="font-semibold text-xl text-darktext">
                                {order.Items?.[0]?.ProductName || 'Order'}
                                {order.Items?.length > 1 && ` +${order.Items.length - 1} more`}
                              </h3>
                              <p className="text-sm text-contentcolor mt-1">
                                Order No: <span className="font-semibold">{order.OrderNo}</span>
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="text-sm text-contentcolor">
                                {new Date(order.EntDt).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric'
                                })} at {new Date(order.EntDt).toLocaleTimeString('en-US', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true
                                })}
                              </p>
                              <span
                                className={`inline-block px-3 py-1 rounded-full text-sm font-medium mt-2 ${order.OrderStatus === "PENDING" ? "bg-orange-100 text-orange-600" :
                                    order.OrderStatus === "CONFIRMED" ? "bg-blue-100 text-blue-600" :
                                      order.OrderStatus === "PREPARING" ? "bg-yellow-100 text-yellow-600" :
                                        order.OrderStatus === "PICKED" ? "bg-purple-100 text-purple-600" :
                                          order.OrderStatus === "DELIVERED" ? "bg-green-100 text-green-600" :
                                            order.OrderStatus === "CANCELED" ? "bg-red-100 text-red-600" :
                                              order.OrderStatus === "REJECTED" ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-600"
                                  }`}
                              >
                                {order.OrderStatus}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Bottom Section */}
                      <div className="flex items-center justify-between pt-4">
                        <p className="text-base text-contentcolor flex items-center">
                          Total Amount:
                          <span className="font-semibold text-darktext text-lg flex items-center ml-2">
                            {currencySymbol} {order.Total}
                          </span>
                        </p>

                        <div className="flex items-center gap-3">
                          <Link
                            to={`/order-details/${order.Id}`}
                            className="bg-theme2 hover:bg-black transition-colors duration-300 text-white px-5 py-2 rounded-full font-semibold text-sm"
                          >
                            View Details
                          </Link>
                          {order.OrderStatus === "PENDING" && (
                            <button
                              onClick={() => handleCancelOrder(order.Id)}
                              className="text-red-500 hover:text-red-700 transition-colors text-xl p-1"
                            >
                              <LuTrash2 />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-12">
                  <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                    <LuShoppingBag className="text-gray-400 text-2xl" />
                  </div>
                  <h3 className="text-lg font-semibold text-darktext mb-2">No Orders Yet</h3>
                  <p className="text-gray-500 mb-4">You haven't placed any orders yet.</p>
                  <Link
                    to="/menu"
                    className="bg-theme2 hover:bg-black transition-colors duration-300 text-white px-6 py-2 rounded-full font-semibold text-sm inline-block"
                  >
                    Start Shopping
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default MyOrder
